<template>
	<Modal v-model="opened" wrapper-class="modal-centered" @closed="close()" @before-open="onBeforeOpen" @before-close="onBeforeClose">
		<template #titlebar>
			<div />
		</template>

		<div v-html="html" />

		<div class="clearfix button-row">
			<button type="button" :class="[ buttonClass ]" @click.stop="onMainButtonClicked()">
				{{ buttonText }}
			</button>

			<button v-if="showCancel" type="button" class="btn-default" @click.stop="close()">
				{{ buttonCancelText }}
			</button>
		</div>
	</Modal>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { Modal } from '@kouts/vue-modal'
import bodyScrollPlugin from 'body-scroll-freezer'
import { setRouteUrlParam } from '../../routes'
import { $on } from '@/js/includes/event-bus';
import { useStore } from '@/js/stores/index';

const store = useStore()
const route = useRoute()

defineExpose({
	open
})

// Vars
let callback = null
let closeCallback = null

// Reactives
const opened = ref(false)
const html = ref('')
const buttonText = ref('')
const buttonClass = ref('')
const showCancel = ref(false)
const buttonCancelText = ref("")

// Emits
const emit = defineEmits(["close"])

// Computeds
const t = computed(() => store.translations)

// Watchers
watch(opened, value => {
	store.genericModalOpened = value
})

// call again the method if the route changes
watch(route, route => {
	// Check if modals should be opened/closed
	opened.value = !!route.query?.genericPopup || false
})

// Functions
function close(){
	emit("close")
	opened.value = false

	if(closeCallback) closeCallback()
}

function open(htmlValue, params = {}){
	html.value = htmlValue
	opened.value = true
	
	buttonText.value = params.buttonText ? params.buttonText : t.value?.genericClose

	buttonClass.value = params.buttonClass ? params.buttonClass : 'btn-success'
	buttonCancelText.value = params.buttonCancelText ? params.buttonCancelText : t.value?.genericClose
	showCancel.value = params.showCancel
	callback = params.callback ? params.callback : false

	// console.log(params.closeCallback());
	closeCallback = params.closeCallback ? params.closeCallback : false
}

function onMainButtonClicked(){
	opened.value = false
	
	if(callback) callback()
}

function onBeforeOpen() {
	setRouteUrlParam('genericPopup', 1)
	bodyScrollPlugin.freeze()
}

function onBeforeClose() {
	setRouteUrlParam('genericPopup', null)
	bodyScrollPlugin.unfreeze()
}

// Lifecycle
onMounted(() => {
	callback = null
	closeCallback = null

	bodyScrollPlugin.init()

})

// Events
$on('close-generic-popup', () => opened.value = false)
</script>